import { ICountry, IOrderReminder } from "@protoplan/types";
import { UserUpdate } from "../store/user/user.slice";
import { axiosInstance } from "./axiosInstance";

export interface Creds
{
  username: string,
  password: string
}

export async function login(login: Creds)
{
  return axiosInstance.post("/users/login", {
    "username": login.username,
    "password": login.password
  })
    .then(resJson => resJson.data as UserUpdate & { success: boolean, csrfToken: string, message: string })
    .catch(error => console.log("Error validating user:", error));
}

export async function forgotPassword(usernameOrEmail: string)
{
  return axiosInstance.post("/users/forgotPassword", {
    "usernameOrEmail": usernameOrEmail
  })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error sending password reset link:", error));
}

export async function registerUser(username: string, password: string, email: string, countryId: number)
{
  return axiosInstance.post("/users/register", {
    "username": username,
    "email": email,
    "password": password,
    "countryId": countryId })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error registering user:", error));
}

export async function getCurrentUser()
{
  return axiosInstance.get("/users/current")
    .then(resJson => resJson.data as {
      userId: number,
      username: string,
      email: string,
      countryId: number,
      currencyId: number;
      currencyCode: string,
      currencySymbol: string,
      premium: boolean,
      orderReminder: IOrderReminder,
      salesTax: number })
    .catch(error => console.log("Error retrieving current user:", error));
}

export async function getMatchingUsers(input: string)
{
  return axiosInstance.post("/users/matchUser", { input })
    .then(resJson => resJson.data as { users: { userId: number, username: string, email: string }[] })
    .catch(error => console.log("Error retrieving users matching input '" + input + "':", error));
}

export async function getCountriesList()
{
  return axiosInstance.post("/users/countries")
    .then(resJson => resJson.data as ICountry[])
    .catch(error => console.log("Error retrieving countries:", error));
}

export async function getPriceDropAlerts()
{
  return axiosInstance.post("/users/priceDropAlerts")
    .then(resJson => resJson.data.priceDropAlerts)
    .catch(error => console.log("Error retrieving price drop alert:", error));
}

export async function updateCountry(countryId: number)
{
  return axiosInstance.post("/users/updateCountry", { countryId: countryId })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error updating country:", error));
}

export async function updateUsername(newUsername: string)
{
  return axiosInstance.post("/users/newUsername", { username: newUsername })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error updating username:", error));
}

export async function updatePassword(newPassword: string, key?: string)
{
  return axiosInstance.post("/users/newPassword", { password: newPassword, key: key })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error updating password:", error));
}

export async function updateSalesTax(salesTax: number)
{
  return axiosInstance.post("/users/updateSalesTax", { salesTax })
    .then(resJson => resJson.data as { success: boolean });
}

export async function updateEmail(newEmail: string)
{
  return axiosInstance.post("/users/updateEmail", { email: newEmail })
    .then(resJson => resJson.data as { success: boolean, emailExists: boolean });
}

export async function postOrderReminder(
  orderReminder: IOrderReminder,
  creds?: { userId: number, hash: string })
{
  return axiosInstance.post("/users/updateOrderReminder", { orderReminder, creds })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error updating user order reminder:", error));
}

export async function updatePriceDropAlerts(priceDropAlerts: boolean)
{
  return axiosInstance.post("/users/updatePriceDropAlerts", { priceDropAlerts })
    .catch(error => console.log("Error updating price drop alert:", error));
}

export async function logoutUser()
{
  return axiosInstance.post("/users/logout")
    .then(resJson => resJson.data as { success: boolean })
    .catch(error => console.log("Error logging out user:", error));
}

export async function deleteUser()
{
  return axiosInstance.post("/users/delete")
    .then(resJson => resJson.data as { success: boolean })
    .catch(error => console.log("Error deleting user:", error));
}
